export default "__VITE_ASSET__QKUk9VPe__"